import React, { useState } from "react"
//import { LanguageContext } from "../../context"
import Logo from "../unida-logo"
import Form from "../form"
import Button from "../button-generic"
import { navigate, useStaticQuery, graphql } from "gatsby"
import Search from "../search/elastic"

 const SlideToggle = (props) => {


   const {
     //title,
     //buttonText,
     path
    } = props

    //const url = typeof window !== 'undefined' ? window.location.href : '';

    const [search, setSearch] = useState('')

    const { siteSearchIndex } = useStaticQuery(
      graphql`
      query SearchIndexQuery {
        siteSearchIndex {
          index
        }
      }
      `
    )


    const handleSearch = ({target}) =>{
      target.preventDefault()
      setSearch(target.value)

    }

    const cleanSearch = () =>setSearch('')


    const handleSubmit = (e, query) => {
      e.preventDefault();
      if(path === "/search"){
          navigate(`?s=${encodeURI(query)}`)
      }else{
          navigate(`/search?s=${encodeURI(query)}`)
      }
    }

    const formFields = [
            {
              'title': "Cercador",
              'name': "s",
              'placeholder': "Digue'ns el que busques",
              'clearIcon': "icons-32-x-32-export-x",
              'iconSize': 32,
              'type': "text",
              'value': search,
              'onChange': handleSearch,
              'onBlur': cleanSearch
            }
    ]

    const clearForm = (e) =>{
      e.preventDefault();
      e.target.value = ""
    }


   //const { t } = useContext(LanguageContext)

   const handleClickOutside = () => {
    // const typed = document.addEventListener('keydown', (event) => {
    //   var name = event.key;
    //   var code = event.code;
    //   return name;

       // Alert the key name and key code on keydown
       //alert(`Key pressed ${name} \r\n Key code value: ${code}`);
    // }, false);

    // if(typed){
       //slideUp();
      // alert("clicked outside")
    // }
   };

   let slideUp = (duration=1000) => {
     let target = document.getElementById("target");
     target.style.transitionProperty = 'height, margin, padding';
     target.style.transitionDuration = duration + 'ms';
     target.style.boxSizing = 'border-box';
     target.style.height = target.offsetHeight + 'px';
     //target.offsetHeight;
     target.style.overflow = 'hidden';
     target.style.height = 0;
     target.style.paddingTop = 0;
     target.style.paddingBottom = 0;
     target.style.marginTop = 0;
     target.style.marginBottom = 0;
     window.setTimeout( () => {
       target.style.display = 'none';
       target.style.removeProperty('height');
       target.style.removeProperty('padding-top');
       target.style.removeProperty('padding-bottom');
       target.style.removeProperty('margin-top');
       target.style.removeProperty('margin-bottom');
       target.style.removeProperty('overflow');
       target.style.removeProperty('transition-duration');
       target.style.removeProperty('transition-property');
     }, duration);
   }

   const useOutsideClick = (callback) => {
   const ref = React.useRef();

   React.useEffect(() => {
     const handleClick = (event) => {
       if (ref.current && !ref.current.contains(event.target)) {
         callback();
       }
     };

     document.addEventListener('click', handleClick, true);

     return () => {
       document.removeEventListener('click', handleClick, true);
     };
   }, [ref, callback]);

   return ref;
 };

 const ref = useOutsideClick(handleClickOutside);

   return (
     <div
      id="target"
      ref={ref}
      >
      <div className="search-logo-wrapper">
        <div className="row">
          <div className="col-md-6">
            <Logo link="/" />
          </div>
          <div className="col-md-6">
            <Button
              className="close"
              iconClassName="icon"
              iconSize={20}
              iconColor="orange"
              icon="icons-32-x-32-export-x"
              onClick={slideUp}
              />
          </div>

        </div>
      </div>
      <div className="form-wrapper">
        <Search searchIndex={siteSearchIndex.index} />
        {/*
        <Form
          fields={formFields}
          buttonText="Cercar a tota la web"
          handleSubmit={handleSubmit}
          clearForm={clearForm}
        />
        */}
      </div>
    </div>
   )
 }


export default SlideToggle
